/* eslint-disable */

import styled from 'styled-components';

type StyledProps = {
  $isMobile?: boolean;
};

export const OrganizationNameCard = styled.h2`
    margin-block: 0;
    justify-content: space-around;
    display: flex;
    margin-bottom: 0.5em;
`;

export const UserNameCard = styled.h4`
    margin-block: 0;
    justify-content: space-around;
    display: flex;
    margin-bottom: 1em;
`;


export const OrganizationInfoCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserInfoCardContainer = styled.div`
  padding: 1em;
`;

export const UserInfoHeaderContainer = styled.div`
  padding-right: 0.5em;
`;

export const OrganizationNameHeader = styled.h6<StyledProps>`
  margin-block: 0;
  display: flex;
  justify-content: center;
  color: white;
  font-size: 0.9375rem;
  font-weight: 500;
  font-family: inherit;
  max-width: 320px;
  overflow-wrap: anywhere;
  width: 100%;
  text-align: center;
`;

export const StyledLogo = styled.img<StyledProps>`
  height: ${({ $isMobile }) => ($isMobile ? '44px' : '46px')};
  width: auto;
  margin-right: 12px;
  display: block;
  object-fit: contain;
  flex-shrink: 0;
  vertical-align: middle;
`;

